import PropTypes from 'prop-types';
import recurlyPaymentTypes from '../../../constants/subscription/recurlyPaymentTypes';
import css from './paymentInformationHeader.module.scss';

export default function PaymentInformationHeader({ billingInformation }) {
  const {
    firstName,
    lastName,
    lastFourNumbers,
    expirationMonth,
    expirationYear,
    zipCode,
    country,
    state,
    paymentType,
  } = billingInformation;
  if (paymentType !== recurlyPaymentTypes.creditCard) {
    return null;
  }

  return (
    <div className={css.section} data-testid="currentCardInfo">
      <p className={css.name}>
        {firstName} {lastName}
      </p>
      <p>
        {state}, {country} {zipCode}
      </p>
      <p>Card Number: **** **** **** {lastFourNumbers}</p>
      <p>
        Expiration Date: {expirationMonth}/{expirationYear}
      </p>
    </div>
  );
}

PaymentInformationHeader.propTypes = {
  billingInformation: PropTypes.object.isRequired,
};
